exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone{background:#fff!important;border:2px dashed #48285e!important;border-radius:20px!important;cursor:pointer!important}.dropzone-message-wrapper{color:#a5a9b1!important}.dropzone-start-message{font-size:54px!important}", ""]);

// exports
